// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import 'app/viewport/components/TopBar/JobsCta.scss';

import { type KindType } from 'app/common/types';

const bem = bemify('jobs-cta');

type JobsCtaProps = {
  className?: string,
  kind?: KindType,
};

const JobsCta = (props: JobsCtaProps) => {
  return (
    <div className={bem(toModifiers(props.kind), props.className)}>
      We’re hiring — <a href="/about/">work remotely</a>
    </div>
  );
};

export default JobsCta;
